import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule ]
})
export class BadgesComponent {

  @Input() badges = [];

  constructor(
    private httpService: KlaHttpService
  ) {
  }

  getImgPath(id) {
    return this.httpService.getImagePath(id, 50);
  }

}
